import React from 'react';
export function ProductPresentation() {
  const features = ['🧠 Basado en fisiología real', '📊 Resultados medibles', '⚡ Desde la noche 1', 'Español neutro'];
  return <section className="w-full bg-navy-light py-16 md:py-24 px-4" data-id="element-254">
      <div className="max-w-4xl mx-auto text-center" data-id="element-255">
        <p className="text-cyan text-sm uppercase tracking-widest mb-4" data-id="element-256">
          EL SISTEMA
        </p>

        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-tight mb-6" data-id="element-257">
          DUERMES…
          <br data-id="element-258" />
          PERO NO DESCANSAS
        </h2>

        <p className="text-cyan text-lg md:text-xl max-w-2xl mx-auto mb-10" data-id="element-259">
          Protocolo científico de 14 noches para desactivar el modo alerta y
          convertir tu sueño en recuperación real.
          <br data-id="element-260" />
          Sin dormir más horas. Sin pastillas. Sin apps.
        </p>

        <div className="mb-10" data-id="element-261">
          <img src="https://cdn.magicpatterns.com/uploads/hY2jRSXJfE7JrLSyrvaahh/portada.png" alt="Duermes Pero No Descansas - Sistema completo" className="max-w-full md:max-w-xl mx-auto rounded-lg shadow-2xl" data-id="element-262" />
        </div>

        <div className="flex flex-wrap justify-center gap-3" data-id="element-263">
          {features.map((feature, index) => <span key={index} className="bg-navy rounded-full px-4 py-2 text-sm text-white border border-cyan/30" data-id="element-264">
              {feature}
            </span>)}
        </div>
      </div>
    </section>;
}